import React, { ReactElement } from "react";
import styles from "./Circle.module.css";

interface CircleProps {
  color: string;
  size?: number;
  onClick?: () => void;
  children: ReactElement;
  className?: string;
}

const Circle: React.FC<CircleProps> = ({
  color,
  size = 48,
  onClick,
  children,
  className,
  ...props
}): ReactElement => {
  return (
    <div
      {...props}
      className={`${styles.circle} ${className}`}
      onClick={onClick ? onClick : null}
      style={{ width: size, height: size, minWidth: size, minHeight: size, background: color }}
    >
      {children}
    </div>
  );
};

export default Circle;
